import React from "react";
import "./pages.css";
import "./pagesResponsiveStylesheet.css";
import RequestAccessImage from "../Assets/Images/Illustrations/request_access.svg"
import MetaData from "../Components/MetaData/MetaData";
import LottieAnimation from "../Assets/Lotties/LottieAnimation";
import Button from "../Components/BasicComponents/Button";

export default class RequestAccess extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            firstName: "",
            lastName: "",
            email: "",
            message: "",
            activeSubmit: false,
            page: "request", //request, success
        }
    }

    validateEmail = (email) =>{

        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email.trim());
    }

    checkValidity = (info) =>{
        return(info !== undefined && info !== null && info.trim().length > 0)
    }


    changeFirstNameHandler = (event) => {
        let {lastName, email } = this.state;
        this.setState({firstName: event.target.value});
        this.checkSubmitBtnStatus(event.target.value, lastName, email)

    }

    changeLastNameHandler = (event) => {
        let { firstName, email } = this.state;
        this.setState({lastName:event.target.value,});
        this.checkSubmitBtnStatus(firstName,event.target.value, email)

    }
    changeEmailHandler = (event) => {
        let { firstName, lastName } = this.state;
        this.setState({email: event.target.value});
        this.checkSubmitBtnStatus(firstName,lastName,event.target.value)

    }

    checkSubmitBtnStatus = (firstName, lastName, email) =>{
        this.setState({
            activeSubmit: this.checkValidity(firstName) && this.checkValidity(lastName) && this.checkValidity(email) && this.validateEmail(email),
        });
    }

    submitRequestAccess = () =>{
        this.setState({
            page: "success"
        })
    }
    render() {
        let {
            toolName,
            page
        } = this.props;
        return (
            <div className="request-access-page">
                <MetaData keyword={"request_early_access"}/>
                {
                    this.state.page === "request" ?
                        <div className="request-access-layout">
                            <div className="request-access-layout--left">
                                <h2 className="request-access-title">
                                    Get Early
                                    Access {toolName !== undefined && toolName !== null && toolName !== "" ? `for ${toolName}` : ""}
                                </h2>
                                <div className="request-access-description">
                                    <p>Be among the first to try it.</p>
                                    <ul>
                                        <li>Use the tool before launch</li>
                                        <li>Influence its development with your feedback</li>
                                        <li>Unlock new features as they roll out</li>
                                    </ul>
                                </div>

                                <div className="request-access-form">
                                    <div className="request-access-form-input">
                                        <input type={"text"} placeholder={"First Name*"}
                                               value={this.state.firstName}
                                               onChange={(event)=>this.changeFirstNameHandler(event)}/>
                                    </div>
                                    <div className="request-access-form-input">
                                        <input type={"text"} placeholder={"Last Name*"}
                                               value={this.state.lastName}
                                               onChange={(event)=>this.changeLastNameHandler(event)}/>
                                    </div>
                                    <div className="request-access-form-input">
                                        <input type={"email"} placeholder={"Work Email*"}

                                               value={this.state.email}
                                               onChange={(event)=>this.changeEmailHandler(event)}/>
                                        {/*onChange={this.changeEmailHandler.bind(this)}/>*/}
                                    </div>
                                    <div className="request-access-form-text-area">
                                        <textarea value={this.state.message} placeholder={"How do you plan to use this tool? (optional)"}/>
                                    </div>
                                    <div className="request-access-form-bottom-row">
                                        <Button disabled={!this.state.activeSubmit} onClick={this.submitRequestAccess.bind(this)}>
                                            Request Early Access
                                        </Button>
                                    </div>
                                </div>
                            </div>
                            <div className="request-access-layout--right">
                                <img src={RequestAccessImage} alt="Email Sending"/>
                            </div>
                        </div>
                        :
                        <div className="request-access-success-layout">
                            <div className="request-access-success-animation">
                                <LottieAnimation lotti={"SuccessMark"} width={200} height={200} />
                            </div>
                            <div className="request-access-success-text">
                                Thank you! Your early access request has been received.
                            </div>
                            {
                                page === "main" &&
                                <div className="request-access-success-bottom-row">
                                    <Button type={"primary"}>Go to Home</Button>
                                </div>
                            }

                        </div>
                }

            </div>
        )
    }
}


LottieAnimation.defaultProps = {
    toolName: "",
    page:"main"
}

LottieAnimation.propsType = {}